import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-8EDKFCNSNF";

export const initGA = () => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const sendWebVitalsToGA = ({ name, delta, id }) => {
    ReactGA.event({
        category: "Web Vitals",
        action: name,
        value: Math.round(name === "CLS" ? delta * 1000 : delta),
        label: id,
        nonInteraction: true,
    });
};
